module.exports = __webpack_public_path__ + "static/8-3f24be8303e77c07216dea4ac42d251e.png";